"use client";

import { Link } from "@faire/web/ui/LinkAnchor";
import React from "react";

import { IProductInfoClientWrapper } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductInfo/ProductInfoClientWrapper/productInfoClientWrapperAdapter";
import { useSearchProductInfoClientWrapperProps } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductInfo/ProductInfoClientWrapper/useSearchProductInfoClientWrapperProps";

export const ProductInfoClientWrapper: React.FC<
  React.PropsWithChildren<IProductInfoClientWrapper>
> = (props) => {
  const linkProps = useSearchProductInfoClientWrapperProps(props);
  return (
    <Link
      onClick={linkProps.onProductClick}
      data-test-id={linkProps["data-test-id"]}
      to={linkProps.productUrl ?? ""}
      replace={linkProps.replace}
    >
      {props.children}
    </Link>
  );
};
